var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBackArrowNav = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "21px",
  height: "21px",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg",
  className: "react-svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 6,
  width: 13,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(4.242641, 4.947715) rotate(-45.000000) translate(-4.242641, -4.947715) ",
  x: -0.257359313,
  y: 3.44771525,
  width: 9,
  height: 3,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "translate(4.242641, 9.774313) rotate(-45.000000) translate(-4.242641, -9.774313) ",
  x: 2.74264069,
  y: 5.27431324,
  width: 3,
  height: 9,
  rx: 1
}))))));
export default SvgBackArrowNav;